import { render, staticRenderFns } from "./ScreeningPersonalInfo.vue?vue&type=template&id=6f88dea2&scoped=true&"
import script from "./ScreeningPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./ScreeningPersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningPersonalInfo.vue?vue&type=style&index=0&id=6f88dea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88dea2",
  null
  
)

export default component.exports